"use client";
import React from "react";
import Image from "next/image";
import useOnScreen from "@/src/hooks/useOnScreen";
import { getTranslateClass } from "@/src/constants/animations";
import { AnimatedImageProps } from "./types";

const AnimatedImage: React.FC<AnimatedImageProps> = ({
  src,
  alt,
  direction,
  width,
  height,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0.1, true);

  return (
    <div
      ref={ref}
      className={`w-full md:w-1/2 flex justify-center transition-transform duration-700 ease-in-out ${
        isIntersecting
          ? "translate-x-0 translate-y-0 opacity-100"
          : `${getTranslateClass(direction)} opacity-0`
      }`}
    >
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        className="rounded-lg shadow-xl object-cover w-full h-auto"
      />
    </div>
  );
};

export default AnimatedImage;
